export interface SubscribeSuccess {
  id: string;
  uuid: string;
  success: boolean;
  account: {
    code: string;
  };
}

export interface ActivateSubscribeSuccess {
  success: boolean;
}

export interface SubscribeError {
  error: string;
}

export function isSubscribeSuccessResponse(
  response: Record<string, any>,
): response is SubscribeSuccess {
  return typeof response.id === 'string';
}

export function isSubscribeErrorResponse(
  response: Record<string, any>,
): response is SubscribeError {
  return typeof response.error === 'string' && response.error !== '';
}
